var React = require('react');

function Shirt (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M81.3,12.428,56.221,0c-2.589,3.58-8.32,6.079-15,6.079S28.8,3.58,26.212,0L1.137,12.428A2.076,2.076,0,0,0,.21,15.2L7.576,29.944a2.076,2.076,0,0,0,2.769.927l7.29-3.568A2.057,2.057,0,0,1,20.6,29.158V61.82a4.117,4.117,0,0,0,4.121,4.121h32.97A4.117,4.117,0,0,0,61.81,61.82V29.145a2.062,2.062,0,0,1,2.962-1.855l7.29,3.568a2.054,2.054,0,0,0,2.769-.927L82.211,15.2a2.056,2.056,0,0,0-.914-2.769Z","transform":"translate(1.653 1.908)","fill":"none","stroke":"#fff","strokeWidth":"3"}));
}

Shirt.defaultProps = {"width":"85.596","height":"69.349","viewBox":"0 0 85.596 69.349"};

module.exports = Shirt;

Shirt.default = Shirt;
